import { loginService } from '@agro1desenvolvimento/apis-js-package';

const useIsCustomer = () => loginService.validateAccess('agroanalisa.customer_panel')
  && loginService.systemActions.length === 1;

export default useIsCustomer;
